module.exports = __webpack_public_path__ + "img/base_divers_pratique_jaime_services.dec74799.svg";